import useFileAccess from "files/hooks/useFileAccess";
import BaseDirectory from "files/types/enums/baseDirectory";
import useUserPermission from "~/hooks/useUserPermission";

/**
 * Hook to check if a user should see top level file browser link in data browser
 */
const useGlobalFileBrowserEnabled = () => {
  const rawAccess = useFileAccess(BaseDirectory.RAW, "read");
  const standardAccess = useFileAccess(BaseDirectory.STANDARD, "read");
  const enrichAccess = useFileAccess(BaseDirectory.ENRICHED, "read");
  const studyManageAccess = useFileAccess(BaseDirectory.STUDY_MANAGEMENT, "read");
  const canViewOrgFiles = rawAccess || standardAccess || enrichAccess || studyManageAccess;
  const canViewPersonalFiles = useUserPermission("view:file-browser-personal-folder");
  const canViewFileBrowser = useUserPermission("view:file-browser");

  return canViewFileBrowser && (canViewOrgFiles || canViewPersonalFiles);
};

export default useGlobalFileBrowserEnabled;
